/**
 * Что показывает карточка товара.
 *
 * Галерея строится по настоящим фотографиям: их адреса приходят готовыми и
 * собирать их самим нельзя — файлы переедут в объектное хранилище, а поле
 * останется тем же (docs/frontend/api-and-mocks.md › Картинки).
 */
import type { Translate } from '../../ui/translate'
import type { Product } from './api'

export interface Spec {
  label: string
  value: string
}

/**
 * Характеристики. Показываем только то, что приходит: строка с прочерком
 * выглядит как «не заполнили», хотя поля просто нет.
 */
export function specs(product: Product, t: Translate): Spec[] {
  const rows: Spec[] = []
  if (product.maker) rows.push({ label: t('catalog:spec.maker'), value: product.maker })
  if (product.categoryName) {
    rows.push({ label: t('catalog:spec.category'), value: product.categoryName })
  }
  rows.push({
    label: t('catalog:spec.release'),
    value: t(product.rx ? 'catalog:spec.rx' : 'catalog:spec.otc'),
  })
  rows.push({
    label: t('catalog:spec.stock'),
    value: t(product.inStock ? 'catalog:spec.inStock' : 'catalog:spec.outOfStock'),
  })
  if (product.texts.storage) {
    rows.push({ label: t('catalog:spec.storage'), value: product.texts.storage })
  }
  return rows
}

/** Чего в характеристиках не хватает: этих полей нет у товара в API. */
export const MISSING_SPECS = 'Действующее вещество, форма выпуска, страна и срок годности'
